import {
    GetBrandBySlugViewModel,
    GetBrandCategoryViewModel,
    GetCategoryBySlugViewModel,
    ProductListSort,
} from '@/types/api'
import { CombinationSlugPageViewModel, TagViewModel } from '@/types/cml-api'

import { PLPBasicMetasProps, PurePLPBasicMetasProps } from '../types'

export function isCategoryMetas(metas: PLPBasicMetasProps | undefined): metas is GetCategoryBySlugViewModel {
    return typeof metas === 'object' && metas !== null && ('nameEn' in metas || 'nameFa' in metas || 'id' in metas)
}

export function isBrandMetas(metas: PLPBasicMetasProps | undefined): metas is GetBrandBySlugViewModel {
    return (
        typeof metas === 'object' &&
        metas !== null &&
        ('name' in metas || 'nameEn' in metas || 'brandId' in metas || ('id' in metas && 'logoUrl' in metas))
    )
}

export function isTagMetas(metas: PLPBasicMetasProps | undefined): metas is TagViewModel {
    return (
        typeof metas === 'object' &&
        metas !== null &&
        ('title' in metas || 'seoH1' in metas || ('id' in metas && 'imageUrl' in metas && 'description' in metas))
    )
}

export function isBrandCategoryMetas(metas: PLPBasicMetasProps | undefined): metas is GetBrandCategoryViewModel {
    return typeof metas === 'object' && metas !== null && 'brand' in metas && 'category' in metas
}

export function isFacetMetas(metas: PLPBasicMetasProps | undefined): metas is CombinationSlugPageViewModel {
    return (
        typeof metas === 'object' &&
        metas !== null &&
        ('categoryId' in metas || 'facet' in metas || 'seo' in metas || ('title' in metas && 'slug' in metas))
    )
}

export function isPurePLPMetas(metas: PLPBasicMetasProps | undefined): metas is PurePLPBasicMetasProps {
    return (
        typeof metas === 'object' &&
        metas !== null &&
        !('brand' in metas && 'category' in metas) && // not a brand-category combination
        ('description' in metas || 'nameFa' in metas || 'nameEn' in metas)
    )
}

export function isValidProductListSort(value: string | string[] | undefined | null): value is ProductListSort {
    if (!value || typeof value !== 'string') return false
    // Using 'as' here is OK because we're checking if `value` is one of the allowed enum values,
    // so casting to ProductListSort is safe for the includes check.
    return Object.values(ProductListSort).includes(value as ProductListSort)
}
